import React from "react";
import Image from "next/image";

const EcosystemSection = () => {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden bg-[#F4F5FB] dark:bg-jacarta-900">
      {/* Background image */}
      <div className="absolute inset-0 flex items-center justify-center opacity-30">
        <div className="relative w-[722px] h-[599px]">
          <Image
            src="/images/ecosystem-background.png"
            alt="Ecosystem background"
            fill
            className="object-contain"
            priority
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-8">
        <div className="text-center mx-auto mb-12">
          {/* Header */}
          <h3 className="text-accent text-2xl font-medium tracking-wider leading-10 mb-2">
            ABOUT IMPACT ARTs
          </h3>

          {/* Main title */}
          <h2 className="font-bold text-[40px] tracking-wide">
            Why this Matters
          </h2>
        </div>

        {/* Description */}
        <div className="text-center max-w-[1260px] mx-auto">
          <p className="font-semibold text-lg leading-[26px]">
            We are creating an ecosystem that leverages technology and
            creativity for real world positive outcomes. We connect
            impact-aligned individuals and organizations for good.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
